// extracted by mini-css-extract-plugin
module.exports = {"container":"_2W32i25","podcast":"_2U46bAa","title":"_1jna9-N","playContainer":"_r5L565G","playBtn":"_OjqVrtP","playBtnIcon":"_1eQkA8i","duration":"_4pzZEC_","showMore":"_15eh2BQ"};